import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Loading, LoadingDone, Error,ToggleAddCompany,ShowAddCompany,HideAddCompany,SetCompanyProduct } from '../../../actions/loading';
import Company from '../../../components/Admin/CompanyProduct/Company';
import AvmSetup from '../../../components/Admin/CompanyProduct/AvmSetup';
import Product from '../../../components/Admin/CompanyProduct/product';





class AddCompany extends Component {
    constructor(props) {
        super(props);
        this.state = { page : 1};
    }
    submit = (values) => {
        if (this.state.page == 3) {

        console.log(values);
        }
        else {
            this.setState({page : this.state.page + 1});
        }
    }



    //Modal for adding company
    componentDidUpdate(prevProps) {
        //initialize the form when the modal is opened and company is updated
        if (this.props.displayModal ) {
            this.props.SetCompanyProduct({"Title" : ['Product 1']});
            console.log("Add Company");

        }
    }
    render() {
    return (
        <Modal
                isOpen={this.props.displayModal}
                contentClassName="custom-large-modal-style"
              >
                <form onSubmit={this.props.handleSubmit(this.submit)} style={{ marginLeft: "0%", marginRight: "0%" }}>
                    <ModalHeader>
                        Add Company
                    </ModalHeader>
                    <ModalBody>
                    
                    {this.state.page == 1 && <Company />}
                    {this.state.page == 2 && <Product />}
                    {this.state.page == 3 && <AvmSetup />}
                    </ModalBody>
                    <ModalFooter>

                        <div className="col-12 pb-2 text-right">
                            <Button color="primary" type="submit" className="mr-3">Save</Button>
                            <Button type="button" onClick={()=> this.setState({page : this.state.page - 1})}>Back</Button>
                            <Button type="button" onClick={()=> this.props.HideAddCompany()}>Cancel</Button>
                        </div>
                    </ModalFooter>
                </form>
        </Modal>
    );
}
  
}
const validate = values => {
    const errors = {};
    if (!values.CompanyName) {
        errors.CompanyName = 'Required';
    }
    return errors;
}
var addCompanyForm = reduxForm({
    form: 'addCompanyForm',
    validate,
    enableReinitialize: true
})(AddCompany);
addCompanyForm = connect(state => ({
    session: state.session,
    loading: state.loading,
    displayModal: state.AddCompany.display,
    initialValues: state.LoadCompanyProduct.product
}), { Loading, LoadingDone, Error, ToggleAddCompany,ShowAddCompany,HideAddCompany,SetCompanyProduct })(addCompanyForm);
export default addCompanyForm;